import React, { useState } from "react";
import PasswordStrenghtMeter from "../PasswordStrenghtMeter";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../components/FormError";
import {useDispatch, useSelector} from "react-redux"
import { updatePassword, reset } from "../../slices/UserSlice";
import * as Yup from "yup";
import { Loading } from "../Loading";
import { MessageModel } from "../../components/MessageModel";
import { useNavigate } from "react-router-dom"

export function ChangePassword() {
  const success = useSelector((state) => state.users.success);
  const message = useSelector((state) => state.users.message);
  const loading = useSelector((state) => state.users.loading);
  const type = useSelector((state) => state.users.type);
  const navigate = useNavigate()
  const formSchema = Yup.object().shape({
    oldPassword: Yup.string()
      .required("Old password is required"),
    newPassword: Yup.string()
      .required("New password is required")
      .min(6, "Password length should be at least 6 characters"),
    confPass: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("newPassword")], "Passwords must and should match"),
  });
  const dispatch = useDispatch()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(formSchema),
  });
  const [newPassword, setNewPassword] = useState("");

  const onSubmit = function(postData) {  
    const {
      confPass,
      ...rest
    } = postData
    dispatch(
      updatePassword(rest)
    )

  }

  const redirectToLogin = () => {
    dispatch(reset())
    if(success){
      window.location.reload();
    } 
}

  return (
    <>
    {loading? <Loading /> :'' }
    <div className="row">
      {/* <span className="border border-light" style={{margin:'auto', width: '70%',}}> */}
        <div className="col-md-6 col-lg-12">
          <div className="card payment-card ">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="card-header">
                <h4 className="card-title text-left">CHANGE PASSWORD</h4>
              </div>
              <div className="card-body pt-0">
                
                  <div className="row">
                    <div className="col-6 ">
                      <div className="form-group mb-3  ">
                        <label htmlFor="oldPassword">Current Password</label>
                        <input
                          type="password"
                          id="oldPassword"
                          {...register("oldPassword")}
                          className={`input-label form-control ${errors.oldPassword && "error"}`}
                          placeholder="Current Password" />
                        {errors.oldPassword && (
                          <FormError message={errors.oldPassword.message} />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 ">
                      <div className="form-group mb-3  ">
                        <label htmlFor="newPassword">New Password</label>
                        <input
                          type="password"
                          className="form-control"
                          {...register("newPassword")}
                          placeholder="New Password"
                          style={{ marginBottom: "3px" }}
                          onChange={(e) => setNewPassword(e.target.value)} />
                        {errors.newPassword && (
                          <FormError message={errors.newPassword.message} />
                        )}
                        <div>
                          <PasswordStrenghtMeter
                            password={newPassword}
                            style={{ marginBottom: "5px" }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 ">
                      <div className="form-group mb-3  ">
                        <label htmlFor="confPass">Confirm Password</label>
                        <input
                          type="password"
                          id="confPass"
                          {...register("confPass")}
                          className={`input-label form-control ${errors.confPass && "error"}`}
                          placeholder="*******" />
                        {errors.confPass && (
                          <FormError message={errors.confPass.message} />
                        )}
                      </div>
                    </div>
                  </div>
              </div>
              <div className="col-12 mb-3 mx-auto  mx-2 text-right">
                <button type="submit" className="btn btn-lg btn-success">
                  Update
                </button>
                <button type="button" className="btn btn-outline-danger btn-lg mx-2">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      
      {/* </span> */}
    </div>
    {type === 'UPDATE_PASSWORD_ERROR' || type === 'UPDATE_PASSWORD_SUCCESS' ? (
                <MessageModel
                    btnEvent={redirectToLogin}
                    error={!success}
                    success={success}
                    message = {message}
                />
            ) : (
                ""
            )}
    </>
  );
}
